<template>
  <div>
    <el-row style="text-align: left">
      <el-col :span="20" :offset="1">
        <form-create v-model="fApi" :rule="rule" :option="option"></form-create>
      </el-col>
    </el-row>
    <el-row style="position: sticky; bottom: 0; background: #ffffff; z-index: 999">
      <el-col :span="20" :offset="3">
        <el-button v-for="(item, index) in buttons" :key="index" size="small" plain :type="btnTypeFormatter(item.Ico)"
          @click="buttonClickHandler(item.Script)">{{ item.Title }}</el-button>
      </el-col>
    </el-row>
    <el-drawer :append-to-body="true" :with-header="false" :visible.sync="refuseDrawer">
      <el-form style="margin: 20px" label>
        <el-form-item label="拒绝原因">
          <el-input type="textarea" v-model="refuseReason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="danger" @click="executeRefuse">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer :size="handoverDrawerSize" :append-to-body="true" :with-header="false" :visible.sync="handoverDrawer">
      <el-form style="margin: 20px" label>
        <el-form-item label="选择转交人">
          <el-input type="text" v-model="handOverName">
            <el-button slot="append" @click="dialogSelectHandOverVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="转交原因">
          <el-input type="textarea" v-model="handOverReason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="danger" @click="executeHanOver">提交</el-button>
        </el-form-item>
      </el-form>
      <el-drawer size="50%" :append-to-body="true" :with-header="false" :visible.sync="dialogSelectHandOverVisible">
        <el-form style="margin: 20px; text-align: center" label>
          <el-form-item>
            <selectMember @ConfirmeValue="confirmHandOver"></selectMember>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="dialogSelectHandOverVisible = false">确认</el-button>
            <el-button size="small" @click="dialogSelectHandOverVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </el-drawer>
    <el-drawer :append-to-body="true" :with-header="false" :visible.sync="ccDrawer">
      <el-form style="margin: 20px" label>
        <el-form-item label="选择抄送人">
          <el-input type="text" v-model="CCUserName">
            <el-button slot="append" @click="dialogSelectCCVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="danger" @click="executeCC">提交</el-button>
        </el-form-item>
      </el-form>
      <el-drawer size="50%" :append-to-body="true" :with-header="false" :visible.sync="dialogSelectCCVisible">
        <el-form style="margin: 20px; text-align: center" label>
          <el-form-item>
            <selectMember @ConfirmeValue="confirmCC"></selectMember>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="dialogSelectCCVisible = false">确认</el-button>
            <el-button size="small" @click="dialogSelectCCVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </el-drawer>
    <el-dialog width="50%" title="选择部门" :visible.sync="dialogSelectFrameVisible">
      <selectFrame @ConfirmeValue="confirmSelect"></selectFrame>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSelectFrameVisible = false">确认</el-button>
        <el-button @click="dialogSelectFrameVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog width="50%" title="选择人员" :visible.sync="dialogSelectMemberVisible">
      <selectMember @ConfirmeValue="confirmSelect"></selectMember>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSelectMemberVisible = false">确认</el-button>
        <el-button @click="dialogSelectMemberVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetUserWorkFlow,
  GetWorkFlowInput,
  GetAttentions,
  GetFieldStatusAndButtons,
  GetFirstStepId,
  GetFlowSendNextSteps,
  GetStepTimeLine,
  ExecuteFlow,
  GetWorkFlowData,
  Cancel,
  Refuse,
  Completed,
  HandOver,
} from "../../until/ZeusApiSDK/Logic/WorkFLowLogic";
import {
  InitFormRule,
  InitFApi,
  GetAttentionRule,
  GetStepTimeLinesRule,
} from "../../until/InitFormRules";
import { Encrypt, Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import bus from "../../until/eventbus";
import selectFrame from "../Structure/SelectFrame";
import selectMember from "../Structure/SelectMember";
export default {
  props: {
    task: {
      type: Object,
    },
    drawerShow: {
      type: Boolean,
    },
    drawerSize: {
      type: String,
    },
  },
  data() {
    return {
      //实例对象
      fApi: {},
      //表单生成规则
      rule: [],
      workflowInput: [], //流程表单
      fieldStatus: [], //字段状态
      buttons: [], //当前步骤按钮
      workflowdata: [],
      steptimeline: [], //步骤时间线
      attention: [], //注意事项
      t: this.task,
      user: {},
      opts: {},
      refuseReason: "",
      selectField: "",
      dialogSelectFrameVisible: false,
      dialogSelectMemberVisible: false,
      dialogSelectHandOverVisible: false,
      dialogSelectCCVisible: false,
      //组件参数配置
      option: {
        //表单提交事件
        onSubmit: function (formData) { },
        submitBtn: false,
        resetBtn: false,
        form: {
          inlineMessage: true,
          statusIcon: true,
          labelWidth: "150px",
        },
      },
      loading: false,
      handoverDrawer: false,
      refuseDrawer: false,
      ccDrawer: false,
      handOver: "",
      handOverName: "",
      handOverReason: "",
      CCUser: "",
      CCUserName: "",
      handoverDrawerSize: "30%",
      isRepeatData: {},
    };
  },
  created() {
    this.getCurrentUser();
    bus.$off("showSelectFrameDialog");
    bus.$off("showSelectMemberDialog");
    if (this.t.isFirstStep) {
    }
    this.InitFlowData();
  },
  mounted() {
    let _this = this;
    bus.$on("showSelectFrameDialog", function (x) {
      _this.dialogSelectFrameVisible = true;
      _this.selectField = x;
    });
    bus.$on("showSelectMemberDialog", function (x) {
      _this.dialogSelectMemberVisible = true;
      _this.selectField = x;
    });
  },
  methods: {
    open: function () {
      this.$alert("<strong>这是 <i>HTML</i> 片段</strong>", "HTML 片段", {
        dangerouslyUseHTMLString: true,
      });
    },

    InitFormRules: function () {
      var cnt = this.t.isFirstStep ? 2 : 1;
      var arr = new Array(this.workflowInput.length + cnt);
      var l = this.rule.length;
      this.rule = this.rule.concat(arr);
      this.workflowInput.forEach(async (element) => {
        var status = this.fieldStatus.filter((p) => p.Field == element.Field);
        var show;
        var check;
        var data;
        if (status.length > 0) {
          show = status[0].Status1;
          check = status[0].Check;
        }
        var d = this.workflowdata.filter((p) => p.Field == element.Field);
        if (d.length > 0) {
          data = d[0].Value;
        } else {
          data = "";
        }
        var r = await InitFormRule(
          element,
          show,
          check,
          data,
          this.t.isFirstStep
        );
        this.rule.splice(element.Sort + l, 0, r);
        if (
          element.InputType == "selectframe" ||
          element.InputType == "selectmember"
        ) {
          element.InputType = "hidden";
          var vr = await InitFormRule(
            element,
            show,
            check,
            data,
            this.t.isFirstStep
          );
          this.rule.splice(element.Sort + l, 0, vr);
        }
        this.rule.sort(function (a, b) {
          return a.sort - b.sort;
        });
      });
    },
    buttonClickHandler: function (type) {
      switch (type) {
        case "send();":
          this.send();
          break;
        case "cancel();":
          this.cancel();
          break;
        case "refuse();":
          this.refuse();
          break;
        case "completed();":
          this.executeCompleted();
          break;
        case "handOver();":
          this.initHandOver();
          break;
        case "sendAndCC();":
          this.initSendAndCC();
          break;
        case "exportData();": //导出当前数据
          this.initExportData();
          break;
      }
    },
    send: function () {
      this.fApi.submit((formData, $f) => {
        //   this.$confirm('如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //确定了干的事

        const loading = this.$loading();
        //如果考勤类的提醒（如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待）

        //离职重复提交提醒
        if (
          this.t.FlowID == "6eaa6762-2595-4df1-ac0c-259835d887aa" &&
          this.t.StepID == "42fe5c31-916b-4fec-b101-33e9a5031418"
        ) {
          if (this.isRepeatData.result == 0) {
            loading.close();
            this.$message({
              message: this.isRepeatData.msg,
              type: "warning",
              center: true,
            });
            return false;
          }
        }
        //产假延期申请
        if (
          this.t.FlowID == "12dc7869-8a64-4648-8ae9-f6561a3c2af2" &&
          this.t.StepID == "ff41cc59-387f-4145-8b8e-978b0654c1a1"
        ) {
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //婚嫁申请
        if (
          this.t.FlowID == "1b92a432-f437-4041-b1e7-3358fc55b3d0" &&
          this.t.StepID == "362cc0a6-566b-4a15-80f2-bcd69b74625e"
        ) {
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //调休申请
        if (
          this.t.FlowID == "20c05ebd-38ef-4c7e-8a5c-a0969514f28d" &&
          this.t.StepID == "4c24c1a3-48e5-4a40-a33d-a0b54bfe6620"
        ) {
          if (formData.Detailed.length == 0) {
            loading.close();
            this.$message({
              message: "加班明细不能为空，请填写加班明细",
              type: "warning",
              center: true,
            });
            return false;
          }
          let crrcount = formData.Detailed.length;
          for (let i = 0; i < formData.Detailed.length; i++) {
            if (formData.Detailed[i].OverStartTime == "" || formData.Detailed[i].OverEndTime == "" || formData.Detailed[i].OverReason == "") {
              crrcount--;
            }
          }
          if (crrcount != formData.Detailed.length) {
            loading.close();
            this.$message({
              message: "加班明细不能为空，请填写加班明细",
              type: "warning",
              center: true,
            });
            return false;
          }
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //事假/病假申请
        if (
          this.t.FlowID == "2454a47a-dbb6-4083-b06f-ea5145464541" &&
          this.t.StepID == "0882126f-aac8-4617-8f2b-f8c6e68be109"
        ) {
          loading.close();
          let days = this.DiffDay(formData.StartTime, formData.EndTime);
          if (days < 0) {
            this.$message({
              message: "请假结束时间不能小于开始时间",
              type: "warning",
              center: true,
            });
            return false;
          } else if (days >= 30) {
            this.$message({
              message: "请假时间不得超过30天,如需要请走邮件审批",
              type: "warning",
              center: true,
            });
            return false;
          }
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //产假申请
        if (
          this.t.FlowID == "5b703139-cceb-4ead-a976-9007cf819240" &&
          this.t.StepID == "61882b92-7eb4-4dea-9527-e330a8939b27"
        ) {
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //陪产假申请
        if (
          this.t.FlowID == "6dae783b-902b-4a4d-91f5-8a20be746da5" &&
          this.t.StepID == "bef2c89c-9488-4e91-a568-8a21137149f2"
        ) {
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //产检假申请
        if (
          this.t.FlowID == "746bd85b-ca07-45cd-97d5-0995f659172c" &&
          this.t.StepID == "f5f5733c-cc9c-47d9-8c78-675c66923d8f"
        ) {
          var Days = this.DiffDay(formData.StartTime, formData.EndTime);
          if (Days < 0) {
            loading.close();
            this.$message({
              message: "产检假请假结束时间不能小于开始时间",
              type: "warning",
              center: true,
            });
            return false;
          }
          formData.StartTime += " 08:30:00";
          formData.EndTime += " 18:00:00";
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //未打卡申请
        if (
          this.t.FlowID == "7b424b3e-e2ab-4985-b689-bcbc0a3d5c21" &&
          this.t.StepID == "351260da-21f6-459b-a146-715e6fc5c213"
        ) {
          const currentDate = new Date();
          const rescurrentDate =
            currentDate.getFullYear() +
            "-" +
            this.p(currentDate.getMonth() + 1) +
            "-" +
            this.p(currentDate.getDate()) +
            " 00:00:00";
          let Days = this.DiffDay(rescurrentDate, formData.SelectDate);
          if (Days > 0) {
            loading.close();
            this.$message({
              message: "提交忘记打卡时间不能超过当前日期",
              type: "warning",
              center: true,
            });
            return false;
          }
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //小产假申请
        if (
          this.t.FlowID == "7b686b2e-dec4-4b82-83c6-0fbed0a72ca1" &&
          this.t.StepID == "4414188f-65e2-40d5-afdc-905840c0ce3a"
        ) {
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //哺乳假申请
        if (
          this.t.FlowID == "8121379e-4942-4ece-9ddf-8c06f48e01c8" &&
          this.t.StepID == "85d845d6-093b-4780-8a34-5834213da637"
        ) {
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }

        //出差申请
        if (
          this.t.FlowID == "ad5adc52-8bfd-4bae-8c02-261644084708" &&
          this.t.StepID == "c3bd3bc3-47ce-4c48-9c5d-b823da752de7"
        ) {
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }

        //如果为出访申请并提交时则存在时间限制,出访时间与当前时间不能超过7天
        if (
          this.t.FlowID == "0fd2266f-c6f1-4118-8a7f-abe5fd721bcd" &&
          this.t.StepID == "5a0a428e-4080-43d2-8dab-ac363aac8dc4"
        ) {
          loading.close();
          const currentDate = new Date();
          const rescurrentDate =
            currentDate.getFullYear() +
            "-" +
            this.p(currentDate.getMonth() + 1) +
            "-" +
            this.p(currentDate.getDate());
          let Day0 = this.DiffDay(formData.StartTime, formData.EndTime);
          if (Day0 < 0) {
            this.$message({
              message: "提交出访结束时间不能早于出访开始时间",
              type: "warning",
              center: true,
            });
            return false;
          }
          let Day1 = this.DiffDay(formData.EndTime, formData.StartTime);
          if (Day1 <= -7) {
            this.$message({
              message: "提交出访时长不能超过7天",
              type: "warning",
              center: true,
            });
            return false;
          }
          let Days = this.DiffDay(rescurrentDate, formData.StartTime);
          if (Days < -45 || Days > 45) {
            this.$message({
              message: "请提交近45天的出访",
              type: "warning",
              center: true,
            });
            return false;
          }
          this.$message({
            message: "如果提交了考勤相关的假勤数据会有1到2天的延迟，请耐心等待",
            type: "warning",
            center: true,
          });
        }
        //加款申请
        if (
          this.t.FlowID == "af2055a8-bfa1-4aa0-bac0-f1aefbb6b6ee" &&
          this.t.StepID == "dfd00ed7-b8d0-4254-9734-11cc52cdaa45"
        ) {
          if (formData.ReturnType == "打款还款") {
            let Days = this.DiffDay(
              formData.PreReturnDate,
              formData.AddAmountDate
            );
            if (Days > 0) {
              loading.close();
              this.$message({
                message: "加款时间不能超过预计还款时间",
                type: "warning",
                center: true,
              });
              return false;
            }
            if (Days < -4) {
              loading.close();
              this.$message({
                message: "预计还款时间不能超过加款时间5天",
                type: "warning",
                center: true,
              });
              return false;
            }
          }
        }
        GetFlowSendNextSteps(
          this.user.UserId,
          this.t.FlowID,
          this.t.StepID,
          this.t.InstanceID
        ).then((nextSteps) => {
          this.opts.flowid = this.t.FlowID;
          this.opts.type = "submit";
          this.opts.taskid = this.t.ID;
          this.opts.isfirststep = this.t.isFirstStep;
          this.opts.stepid = this.t.StepID;
          this.opts.instanceid = this.t.InstanceID;
          this.opts.ccid = this.t.CCID;
          this.opts.title = this.t.Title;
          this.opts.senderid = this.user.UserId;
          this.opts.senderName = this.user.TrueName;
          this.opts.data = this.exchangeFormData(formData);
          this.opts.step = [];
          nextSteps.forEach((element) => {
            if (element.DefaultMemberID) {
              this.opts.step.push({
                id: element.Step.ID,
                member: element.DefaultMemberID,
              });
            } else {
              this.$message({
                message: "步骤找不到处理人",
                type: "warning",
                center: true,
              });
              return false;
            }
          });
          if (this.opts.step.length == 0) {
            this.$message({
              message: "找不到下一步",
              type: "warning",
              center: true,
            });
            return false;
          }
          ExecuteFlow(this.opts).then((res) => {
            if (res.result == 1) {
              if (this.t.isFirstStep) {
                var to = {
                  name: "UserCreate",
                  params: { taskid: res.taskid },
                };
                this.$router.push(to);
              } else {
                this.ccDrawer = false;
                this.$emit("update:drawerShow", false);
              }
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
                center: true,
              });
            }
            loading.close();
          });
        });
      });
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消操作'
      //     });
      //   });
    },
    //计算两个日期相差天数
    DiffDay: function (startTime, endTime) {
      var dateSpan, tempDate, iDays;
      startTime = Date.parse(startTime);
      endTime = Date.parse(endTime);
      dateSpan = endTime - startTime;
      //dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays;
    },
    cancel: function () {
      Cancel(this.t.ID, this.t.FlowID, this.t.InstanceID, this.t.StepID).then(
        (res) => { }
      );
    },
    refuse: function () {
      this.$emit("update:drawerSize", "50%");
      this.refuseDrawer = true;
    },
    initHandOver: function () {
      this.$emit("update:drawerSize", "50%");
      this.handoverDrawer = true;
    },
    initSendAndCC: function () {
      this.$emit("update:drawerSize", "50%");
      this.ccDrawer = true;
    },
    executeCompleted: function () {
      this.fApi.submit((formData, $f) => {
        this.opts.flowid = this.t.FlowID;
        this.opts.type = "completed";
        this.opts.isfirststep = this.t.isFirstStep;
        this.opts.stepid = this.t.StepID;
        this.opts.instanceid = this.t.InstanceID;
        this.opts.ccid = this.t.CCID;
        this.opts.taskid = this.t.ID;
        this.opts.title = this.t.Title;
        this.opts.senderid = this.user.UserId;
        this.opts.senderName = this.user.TrueName;
        this.opts.data = this.exchangeFormData(formData);
        this.opts.step = [];
        Completed(this.opts).then((res) => {
          if (res.result == 1) {
            this.$emit("update:drawerShow", false);
            this.$message({
              message: res.msg,
              type: "success",
              center: true,
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
              center: true,
            });
          }
        });
      });
    },
    executeRefuse: function () {
      this.opts = {};
      this.opts.flowid = this.t.FlowID;
      this.opts.taskid = this.t.ID;
      this.opts.type = "refuse";
      this.opts.instanceid = this.t.InstanceID;
      this.opts.note = this.refuseReason;
      this.opts.comment = this.refuseReason;
      Refuse(this.opts).then((res) => {
        if (res.result == 1) {
          this.refuseDrawer = false;
          this.$emit("update:drawerShow", false);
          this.$message({
            message: res.msg,
            type: "success",
            center: true,
          });
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
            center: true,
          });
        }
      });
    },
    executeHanOver: function () {
      if (this.handOverReason) {
        let loading = this.$loading({
          lock: true,
          text: "转交中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.2)",
        });
        HandOver(
          this.user.TrueName,
          this.handOverName,
          this.t.ID,
          this.handOver,
          this.handOverReason
        ).then((res) => {
          loading.close();
          if (res.Result == 1) {
            this.handoverDrawer = false;
            this.$emit("update:drawerShow", false);
            this.$message({
              message: "转交成功",
              type: "success",
              center: true,
            });
          } else {
            this.$message({
              message: "转交失败",
              type: "warning",
              center: true,
            });
          }
        });
      } else {
        this.$message({
          message: "请填写转交原因",
          type: "warning",
          center: true,
        });
      }
    },
    executeCC: function () {
      this.t.CCID = this.CCUser;
      this.send();
    },
    getInitFapi: function () {
      InitFApi(this.fApi);
    },
    getCurrentUser: function () {
      var userinfo = window.sessionStorage.getItem("userinfo");
      this.user = JSON.parse(Decrypt(userinfo));
    },
    getUserWorkFlow: function () {
      GetUserWorkFlow(this.user.UserId, this.t.FlowID).then((res) => {
        this.isRepeatData = res;
      });
    },
    //数据导出
    initExportData: function () {
      window.location.href =
        "http://flow.text.ruizhiqi.com/ExportData/ExcelWorkFlowDataByOne?title=" +
        this.t.Title +
        "&flowid=" +
        this.t.FlowID +
        "&instanceid=" +
        this.t.InstanceID;
    },
    exchangeFormData: function (formData) {
      var data = [];
      var keys = Reflect.ownKeys(formData);

      keys.forEach((element) => {
        if (
          !element.endsWith("_static") &&
          !element.endsWith("_input") &&
          element != "stepTimeLine"
        ) {
          var value = Reflect.get(formData, element);
          var strFlag = false;
          var objFlag = false;
          if (value instanceof Array) {
            if (value.length > 0) {
              if (typeof value[0] == "string") {
                strFlag = true;
              }
              if (typeof value[0] == "object") {
                objFlag = true;
              }
              if (strFlag) {
                value = value.join(",");
              }
              if (objFlag) {
                value = JSON.stringify(value);
              }
            }
          }
          data.push({ field: element, value: value });
        }
      });
      return data;
    },
    InitFlowData: async function () {
      //   this.flowid = this.$route.params.flowid;
      //   this.flowname = this.$route.params.flowname;
      //   this.pageTitle = "发起" + this.flowname;
      this.rule = [];
      if (this.t.isFirstStep) {
        this.t.StepID = await GetFirstStepId(this.t.FlowID);
        GetAttentions(this.t.FlowID).then((res) => {
          if (res) {
            var arr = res.split(";");

            arr.forEach((element) => {
              this.attention.push(element);
            });
            if (this.attention.length > 0) {
              this.rule.push(GetAttentionRule(this.attention));
            }
          }
        });
      }
      GetWorkFlowInput(this.t.FlowID).then((res) => {
        this.workflowInput = res;
        GetFieldStatusAndButtons(this.t.FlowID, this.t.StepID).then(
          (fieldAndButtons) => {
            this.fieldStatus = fieldAndButtons.fieldStatus;
            this.buttons = fieldAndButtons.buttonList;
            if (this.t.InstanceID) {
              GetWorkFlowData(this.t.FlowID, this.t.InstanceID).then(
                (workflowdata) => {
                  workflowdata.forEach((element) => {
                    //循环遍历图片
                    if (
                      element.Value != null &&
                      element.Value.indexOf("https") != -1
                    ) {
                      //存在图片字符串
                      if (element.Value.indexOf(",") != -1) {
                        //存在多个图片
                        var newList = element.Value.split(",");
                        var imageUrl = "";
                        //循环遍历图片
                        newList.forEach((item) => {
                          if (item != null && item.indexOf("https") != -1) {
                            //存在字符串
                            item = item.replace("https", "http");
                          }
                          imageUrl += item + ",";
                        });
                        imageUrl = imageUrl.substring(0, imageUrl.length - 1);
                        element.Value = imageUrl;
                      } else {
                        element.Value = element.Value.replace("https", "http");
                      }
                      //element.Value=newList;
                      //element.Value=element.Value.replace("https","http");
                    }
                  });
                  this.workflowdata = workflowdata;
                  this.InitFormRules();
                  this.getInitFapi();
                  this.GetTimeLineRule();
                }
              );
            } else {
              this.InitFormRules();
              this.getInitFapi();
              this.GetTimeLineRule();
              this.getUserWorkFlow();
            }
          }
        );
      });
    },
    GetTimeLineRule: function () {
      GetStepTimeLine(
        this.user.UserId,
        this.t.FlowID,
        this.t.StepID,
        this.t.InstanceID
      ).then((res) => {
        this.steptimeline = res.TimeLines;
        var rule = GetStepTimeLinesRule(this.steptimeline);
        this.rule.push(rule);
      });
    },
    btnTypeFormatter: function (ico) {
      if (ico.indexOf("info") > 0) {
        return "primary";
      } else if (ico.indexOf("warning") > 0) {
        return "warning";
      } else if (ico.indexOf("danger") > 0) {
        return "danger";
      } else {
        return "primary";
      }
    },
    confirmSelect: function (data) {
      if (data.length > 0) {
        var nameArr = [];
        var valueArr = [];
        data.forEach((element) => {
          nameArr.push(element.label);
          valueArr.push(element.key);
        });
        this.fApi.model()[this.selectField].value = valueArr.join(",");
        this.fApi.model()[this.selectField + "_input"].value =
          nameArr.join(",");
      } else {
        this.fApi.model()[this.selectField].value = "";
        this.fApi.model()[this.selectField + "_input"].value = "";
      }
    },
    confirmHandOver: function (data) {
      (this.HandOver = ""), (this.handOverName = "");
      if (data.length > 0) {
        if (data.length == 1) {
          var nameArr = [];
          var valueArr = [];
          data.forEach((element) => {
            nameArr.push(element.label);
            valueArr.push(element.key);
          });
          this.handOver = valueArr.join(",");
          this.handOverName = nameArr.join(",");
        } else {
          this.$message({
            message: "转交人只能选择一个",
            type: "warning",
            center: true,
          });
        }
      } else {
        this.handOver = "";
        this.handOverName = "";
        this.$message({
          message: "请选择转交人",
          type: "warning",
          center: true,
        });
      }
    },
    confirmCC: function (data) {
      this.ccuser = "";
      if (data.length > 0) {
        var nameArr = [];
        var valueArr = [];
        data.forEach((element) => {
          nameArr.push(element.label);
          valueArr.push(element.key);
        });
        this.CCUser = valueArr.join(",");
        this.CCUserName = nameArr.join(",");
      } else {
        this.CCUser = "";
        this.CCUserName = "";
      }
    },
    //时间转换 不够10 添加0
    p(s) {
      return s < 10 ? "0" + s : s;
    },
  },
  watch: {
    task: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.t = n;
        this.InitFlowData();
        this.opts = {};
        this.selectField = "";
      },
      deep: true,
    },
    refuseDrawer: {
      handler(n, o) {
        //n为新值,o为旧值;
        if (!n) {
          this.$emit("update:drawerSize", "30%");
        }
      },
    },
    handoverDrawer: {
      handler(n, o) {
        //n为新值,o为旧值;
        if (!n) {
          this.$emit("update:drawerSize", "30%");
        }
      },
    },
    ccDrawer: {
      handler(n, o) {
        //n为新值,o为旧值;
        if (!n) {
          this.$emit("update:drawerSize", "30%");
        }
      },
    },
  },
  components: {
    selectFrame,
    selectMember,
  },
};
</script>
<style lang="less" scoped>
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

/deep/.el-select {
  width: 100%;
}

/deep/ .el-checkbox-group {
  min-height: 40px;
  line-height: 40px;
}

/deep/.el-cascader {
  width: 100%;
}

/deep/.attention {
  text-align: left;
  font-size: 12px;
  color: crimson;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  line-height: 30px !important;
  transition: 2s;
}

/deep/.el-form-item__content {
  line-height: unset !important;
}

/deep/.el-form-item {
  margin-bottom: 5px !important;
}
</style>
